export const CALENDAR_VIEW_TYPES = ["day", "week", "month"];

export const CALENDAR_VIEW = {
  DAY: "day",
  WEEK: "week",
  MONTH: "month"
};

export const KEY_LAST_CALENDAR_VIEW = "last_calendar_view";
